export const login = function (userdata) {
  return {
    type: 'LOGIN',
    userdata,
  };
};

export const logout = function (userdata) {
  return {
    type: 'LOGOUT',
    userdata,
  };
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export const signIn = function (userdata) {
  return {
    type: 'SET_USER',
    userdata,
  };
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-unused-modules
export const activate = function (userdata) {
  return {
    type: 'ACTIVATE',
    userdata,
  };
};

export const setDeletedUser = function (userdata) {
  return {
    type: 'SET_DELETED_USER',
    userdata,
  };
};

export const setFilterData = function (data) {
  return {
    type: 'SET_USER_FILTERS',
    data,
  };
};

export const setFilterFlag = function (data) {
  return {
    type: 'SET_USER_FILTER_FLAG',
    data,
  };
};
